export default function ({state, commit, dispatch}, {partner, id}) {
    commit('legals');
    axios({
        method: 'POST',
        url: '/tourclient/masterAgent/dictionary/partnerLegal/list',
        data: {request: JSON.stringify({PartnerId: partner})},
    }).then(({data}) => {
        let error = '';
        if (!data) {
            error = 'Не удалось получить список юр.лиц';
        } else if (data.ResultQueryInfo && data.ResultQueryInfo.UserMessages) {
            error = data.ResultQueryInfo.UserMessages;
        }
        if (error) {
            window.app.$notify.error({
                title: 'Ошибка',
                message: error,
            });
        } else {
            commit('legals', data.Items);
            if (!id) {
                let legal = data.Items.filter(i => {
                    return i.IsMain;
                })[0];
                if (legal) id = legal.Id;
                else id = data.Items[0].Id;
            }
        }
        commit('set', {
            PartnerLegalId: id
        });
    }).catch(e => {
        if (!e) return;
        dispatch('error', e, {root: true});
    });
}